export { FileExtensionData } from './schema/FileExtensionData';
export { FileExtensionType } from './schema/FileExtensionType';

// Exported utils
export { getFileExtensionData } from './utils/getFileExtensionData';
